import { mapState } from 'vuex';

export default {
  data () {
    return {
      hasPageAccess: true,
    };
  },

  computed: {
    ...mapState({
      user: (state) => state.account.user,
      permissionsLoaded: (state) => state.account.permissionsLoaded,
    }),
  },

  watch: {
    hasPageAccess (v) {
      if (!v) {
        this.$nuxt.error({
          statusCode: 403,
        });
      }
    },
  },

  methods: {
    isGranted (requiredPermissionsArg = []) {
      const permissions = this.$store.state.account.permissions || [];
      const requiredPermissions = typeof requiredPermissionsArg === 'string'
        ? [requiredPermissionsArg]
        : requiredPermissionsArg;

      return requiredPermissions.every((allow) => permissions.includes(allow));
    },

    canViewPageWithPermissions (requiredPermissionsArg) {
      if (!this.permissionsLoaded) {
        this.$store.subscribe((mutation, state) => {
          if (mutation.type === 'account/set_permissions') {
            this.hasPageAccess = this.isGranted(requiredPermissionsArg);
          }
        });
      } else {
        this.hasPageAccess = this.isGranted(requiredPermissionsArg);
      }

      return this.hasPageAccess;
    },
  },
};
